import React from 'react'
import { Button, Modal, Toast } from '@ow/comps'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'

const Recovery = function ({ children }) {
  const { selectedIds, fetchTbData, recoverTbData } = useTbViewStore((state) =>
    pick(state, ['selectedIds', 'fetchTbData', 'recoverTbData'])
  )

  const confirm = () => {
    recoverTbData(selectedIds).then(() => {
      Toast.success('操作成功！')
      fetchTbData()
    })
  }
  const renderRooter = ({ close }) => {
    return (
      <>
        <Button
          type="secondary"
          opacityType="sm"
          style={{ marginRight: '10px' }}
          onClick={() => {
            close()
          }}
        >
          取消
        </Button>
        <Button
          type="primary"
          onClick={() => {
            confirm()
            close()
          }}
        >
          确定
        </Button>
      </>
    )
  }
  return (
    <Modal
      title="批量恢复"
      nested
      size="sm"
      trigger={selectedIds.length && children}
      footer={({ close }) => {
        return renderRooter({ close })
      }}
    >
      <div className="overflow-y-auto" style={{ height: '3rem' }}>
        <div>确认恢复吗？</div>
      </div>
    </Modal>
  )
}

export default Recovery
